import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { mobile } from '../responsive';




const Container = styled.div`
position: relative;
flex: 1;
margin: 3px;
height: 70vh;`
;

const Image = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
${mobile({height: "30vh"})}
`;

const Info = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`;

const Title = styled.h1`
color: white;
margin-bottom: 20px;
`;

const Button = styled.button`
background-color: white;
color: grey;
border: none;
padding: 10px;
font-weight: 600;
cursor: pointer;
`;

const CategoryItem = ({item}) => {
  return (
    <Container>
      <Link to={`/products/${item.cat}`}>
        <Image src={item.img}/>
        <Info>
          <Title>{item.title}</Title>
          <Button>SHOP NOW</Button>
        </Info>
        </Link>
    </Container>
  )
}

export default CategoryItem